import { types } from './featuresActions';

const initialState = {
    pending: false,
    payload: {},
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.HTTP_PENDING_FEATURES:
            return {
                ...state,
                pending: true
            }
        case types.HTTP_SUCCESS_FEATURES:
            return {
                ...state,
                pending: false,
                payload: action.payload
            }

        case types.HTTP_ERROR_FEATURES:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}

